// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UeXa","largestCol":"styles_largestCol__2SPWj","smallestCol":"styles_smallestCol__1GGT3"};